import Vue from 'vue'
import Router from 'vue-router'
import Orders from '@/components/dashboard/orders'
import Test from '@/components/tests/test'
import BundleAus from '@/components/bundles/aus/landingAus'
import BundleUk from '@/components/bundles/uk/landingUk'
import cookie from '@/components/cookies/cookie-policy'
import login from '@/components/login/login'
import comingSoon from "@/components/coming_soon/comingSoon";
import stats from '@/components/stats/stats'

Vue.use(Router)

const router = new Router({
  mode: 'history', // remove to get # instead of normal urls
  routes: [

    { path: '*', redirect: '/topup/login' },

    {
      path: '/topup/dashboard',
      name: 'Orders',
      component: Orders,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/topup/login',
      name: 'login',
      component: login
    },

    {
      path: '/test',
      name: 'Test',
      component: Test
    },

    {
      path: '/topup/uk',
      name: 'BundleUk',
      component: BundleUk
    },

    {
      path: '/topup/aus',
      name: 'comingSoon',
      component: comingSoon
    },

    {
      path: '/cookie-policy',
      name: 'cookie',
      component: cookie
    }

  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires session cookie, check if logged in
    // if not, redirect to login page.
    if (!window.$cookies.get('session')) {
      next({
        path: 'login'
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
